export const graphInteractionStyles = [
  {
    selector: "edge:selected",
    style: {
      width: 3,
      "line-color": "#FDD835",
      "target-arrow-color": "#FDD835",
      "line-opacity": 1
    }
  },
  {
    selector: 'edge:hover',
    style: {
      width: 4,
      'line-color': '#1976D2',
      'target-arrow-color': '#1976D2',
      'line-opacity': 1,
      'overlay-opacity': 0,
      'underlay-color': '#90CAF9',
      'underlay-opacity': 0.35,
      'underlay-padding': 6,
      cursor: 'pointer'
    }
  },
  {
    selector: 'edge.transaction-selected',
    style: {
      width: 4,
      'line-color': '#FDD835',
      'target-arrow-color': '#FDD835',
      'line-opacity': 1,
      'arrow-scale': 2,
      'z-index': '999'
    }
  },
  {
    selector: "node.highlighted",
    style: {
      width: '108px',
      height: '108px',
      "background-color": "#9C27B0",
      "border-color": "#7B1FA2",
      "border-width": "4px",
      "box-shadow": "0px 0px 25px rgba(156, 39, 176, 0.9)",
      "z-index": "999"
    }
  },
  {
    selector: "edge.highlighted",
    style: {
      width: 4,
      "line-color": "#9C27B0",
      "target-arrow-color": "#9C27B0",
      "line-opacity": 1,
      "arrow-scale": 2,
      "z-index": "999"
    }
  },
];
